import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

import { SeletorDeEpisodios } from './SeletorDeEpisodios';
import { type EpisodioItem } from './helpers';
import { mpfRadioSchema } from './schema';

/**
 * Formulário da barra lateral.
 *
 * `withObjectBrowser` é obrigatório aqui: os campos de áudio e de link do
 * episódio usam `widget: 'object_browser'` dentro de um `object_list`, e sem o
 * wrapper o navegador de conteúdo não abre (mesma razão de
 * `Blocks/Destaques/Data.tsx`).
 *
 * O seletor de episódios do feed é renderizado DEPOIS do formulário, e não
 * como widget do campo `feed`: um widget só sabe mexer no próprio campo, e
 * aqui é preciso escrever em `episodios` — o que exige o `data` e o
 * `onChangeBlock` que só este componente tem em mãos.
 */
const Data = (props) => {
  const { block, blocksConfig, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = mpfRadioSchema({
    intl,
    activeObject: props.activeObject,
    setActiveObject: props.setActiveObject,
  });

  const dataAdapter =
    blocksConfig?.[data['@type']]?.dataAdapter ??
    (({ block: b, data: d, id, onChangeBlock: onChange, value }) =>
      onChange(b, { ...d, [id]: value }));

  const adicionarEpisodio = React.useCallback(
    (episodio: EpisodioItem) => {
      onChangeBlock(block, {
        ...data,
        episodios: [...(data?.episodios ?? []), episodio],
      });
    },
    [block, data, onChangeBlock],
  );

  return (
    <>
      <BlockDataForm
        {...props}
        schema={schema}
        title={schema.title}
        onChangeField={(id, value) =>
          dataAdapter({ block, data, id, onChangeBlock, value })
        }
        onChangeBlock={onChangeBlock}
        formData={data}
        block={block}
      />

      <SeletorDeEpisodios
        feed={data?.feed}
        escolhidos={data?.episodios}
        onAdd={adicionarEpisodio}
      />
    </>
  );
};

export default withObjectBrowser(Data);
